import { CONSULTA_FORM } from '../../../config/forms'
import { toast } from 'react-toastify'
import CorreoElectronico from '../../../models/correoElectronico/correoElectronico'
import { getFormValues, reset } from 'redux-form'

export function submitMensajeConsulta () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(CONSULTA_FORM)(state)
    if (formValues) {
      return CorreoElectronico.enviarCorreoConsulta(formValues)
        .then((response) => {
          dispatch({ type: 'SUBMIT_MENSAJE_CONSULTA' })
          toast.success('Su mensaje fue enviado correctamente. En breve nos pondremos en contato.')
        })
        .catch((e) => {
          console.log(e)
          toast.error('Error al intentar envir el mensaje.')
        })
    } else {
      toast.error('Error al intentar envir el mensaje.')
    }
    dispatch(reset(CONSULTA_FORM))
  }
}
